export const HOME = {en: "Home" , tr: "Ana Sayfa"};
export const ABOUT = {en: "About", tr: "Hakkımızda"};
export const SERVICES = {en: "Our Services", tr: "Servislerimiz"};
export const GALLERY = {en: "Gallery" , tr: "Galeri"};
export const CONTACT = {en: "Contact", tr: "İletişim"};